import React from "react";
import "./change-bed.less";
import { withRouter } from "react-router";
import { setHeader } from "@/util/set-header";
import { changeRoomApi,changeroomSaveApi,changeroomCancelApi } from "@/api/sany";
import { PhotoProvider, PhotoConsumer } from 'react-photo-view';
import 'react-photo-view/dist/index.css';
import  moment  from "moment";
import { NoticeBar, Steps, TextareaItem, Button, Modal, Accordion, Toast } from "antd-mobile";
const Step = Steps.Step
const nowTimeStamp = Date.now();
const now = new Date(nowTimeStamp);

@(withRouter as any)
export default class ChangeBed extends React.Component<any, any> {
  state = {
    roomInfo:{
      store_name:'',
      building_no:'',
      room_no:'',
      bed_no:'',
      property:'',
      room_type_name:'',
      add_time:'',
      exit_time:'',
      pay_type:'',
      total:'',
      primary_organization:'',
      pay_type_department:'',
      pay_type_id:'',
    },
    notice: '换房申请提交后不可修改，请及认真填写换房信息哦~',
    date: now,
    reason: '',
    is_need_sign:false,
    changeId:'',
    status: '99', //  换房申请:apply 审核中:audit 已完成:done 已取消:cancel 已驳回:reject 已过期:expired
  }
  roomObj:any = {
      room_id:'',
      room_type:'',
      bed_id:'',
      img:'',
      roomTypeName:'',
      room_property_name:'',
      storeName:'',
      building_no:'',
      room_no:'',
      bed_no:'',
      property:'',
  } 
  //新换房间信息
  applyRoom:any = {
    add_time: '',
    bed_no: '',
    building_no: '',
    change_room_time: '',
    id: '',
    image: '',
    is_need_sign: false,
    pay_type: '',
    property: '',
    reject_reason: '',
    remark: '',
    room_no: '',
    room_type_name: '',
    status: '',
    status_info: '',
    store_name: '',
    update_time: '',
    apply_organization: '',
    pay_type_id: '',
  } //新换房间信息
  checkinId = ''
  customerId= ''
  constructor(prop: any) {
    super(prop)
    this.leftClick = this.leftClick.bind(this)
    this.goHomePage = this.goHomePage.bind(this)
    this.stepComponent = this.stepComponent.bind(this)
    this.changeBedComponent = this.changeBedComponent.bind(this)
    this.getInput = this.getInput.bind(this)
    this.getSelect = this.getSelect.bind(this)
    this.submitButton = this.submitButton.bind(this)
    this.submitClick = this.submitClick.bind(this)
    this.remarkChange = this.remarkChange.bind(this)
    this.changeRoom = this.changeRoom.bind(this)
    this.getRoomSave = this.getRoomSave.bind(this)
  }

  componentDidMount() {
    setHeader({title: '换房', leftToHome: this.goHomePage, leftClick: this.leftClick});
    (this.refs.body as any).addEventListener('scroll', this.throttle(this.scrollAction))
    // this.changeRoom('add')
  }
  scrollAction() {
    console.log('scroll')
  }
  componentWillReceiveProps() {
    const obj:any = (sessionStorage.getItem('roomObj'))
    this.roomObj = JSON.parse(obj)
    const checkinId:any = (sessionStorage.getItem('checkinId'))
    const customerId:any = (sessionStorage.getItem('customerId'))
    this.checkinId = JSON.parse(checkinId)
    this.customerId = JSON.parse(customerId)
    if(this.props.location.state&&this.props.location.state.type) {
      this.changeRoom(this.props.location.state.type)
    } else {
      this.changeRoom(1)
    }
  }
  changeRoom(val:any) {
    changeRoomApi({checkin_id:sessionStorage.getItem('checkinId'), type:val}).then((res:any)=>{
      if(res.data.code === 'SUCCESS') {
        this.setState({
          status:res.data.data.apply_room.status || '99',
          changeId:res.data.data.apply_room.id,
          roomInfo:res.data.data.primary_room,
          is_need_sign:res.data.data.apply_room.is_need_sign
        })
        this.applyRoom = res.data.data.apply_room || ''
        this.configNotice()
      } else {
        Toast.info(res.data.msg)
      }
    })
    this.configNotice()
  }
  
  // 节流函数
 throttle(fn: any, interval = 1000) {
    let canRun = true;
    return () => {
        if (!canRun) return;
        canRun = false;
        setTimeout(() => {
            fn.apply(this);
            canRun = true;
        }, interval);
    };
}

  leftClick() {
    //返回App
    const { history } = this.props
    if (history.length > 1) {
      // history.goBack()
      this.props.history.push({
        pathname: '/sany/dorm-list'
      })
    } else {
      window.location.href = "uhomeoc://thirdparty.goBack?params={type:native}"
    }
  }

  goHomePage() {
    this.props.history.replace('/sany/dorm-list')
  }

  // 滚动通知栏
  noticeBarComponent() {
    return <NoticeBar marqueeProps={{ loop: true, style: { padding: '0 7.5px' } }}>{this.state.notice}</NoticeBar>
  }

  // 驳回原因
  rejectReasonComponent() {
    return (
      <div className="component-body">
        <div className="lease-status">
          <span style={{fontSize: '14px', color: '#515151', width: '100px'}}>驳回原因：</span>
          <span style={{color: '#868686', fontSize: '12px', overflowWrap: 'break-word', width: '250px', textAlign: 'right'}}>{this.applyRoom.reject_reason}</span>
        </div>
      </div>
    )
  }

  // 去签约
  goSignComponent() {
    return (
      <div className="component-body">
        <div className="go-sign">
          <Button className="go-sign-btn" onClick={() => this.goSignClick()}>去签约</Button>
          <span style={{fontSize: '12px', color: '#515151'}}>换房成功！新房间签约后到期可入住，马上签约吧~</span>
        </div>
      </div>
    )
  }

  goSignClick() {
    this.props.history.push({pathname: '/sany/sign'})
  }

  // 步骤条
  stepComponent() {
    // 1：待审核 2：换房中 3：已换房 4：已取消 5：已驳回 6：已失效
    const status2 = this.state.status !== '99' ? 'finish' : 'wait'
    const status = this.state.status !== '99' ? (this.state.status !== '1'&& this.state.status !== '2' ? 'finish' : 'wait') : 'wait'
    const title = this.state.status !== '99' ? (this.state.status !== '1' && this.state.status !== '2' ? this.applyRoom.status_info : '完成换房') : '完成换房'
    const step2Icon = this.state.status !== '99' ? '/public/assets/img/step_loading_select.png' : '/public/assets/img/step_loading.png'
    let step3Icon = '/public/assets/img/step_room.png'
    if (this.state.status === '3') {
      step3Icon = '/public/assets/img/step_room_select.png'
    } else if (this.state.status === '1') {
      step3Icon = '/public/assets/img/step_room.png'
    } else if (this.state.status === '4' || this.state.status === '5' || this.state.status === '6') {
      step3Icon = '/public/assets/img/step_end.png'
    } else {
      step3Icon = '/public/assets/img/step_room.png'
    }
    const applyTime = this.applyRoom.add_time ? moment(this.applyRoom.add_time).format('yyyy-MM-DD') : ''
    const endTime = this.applyRoom.update_time ? moment(this.applyRoom.update_time).format('yyyy-MM-DD') : ''
    return (
      <div className="step-body">
        <Steps direction="horizontal" size="small">
          <Step status="finish" title={this.customTitle('换房申请', 'finish')} description={this.customDesc(applyTime, 'finish')} icon={this.customIcon('/public/assets/img/step_start_select.png')} />
          <Step status="wait" title={this.customTitle('宿管处理中', status2)} description={this.customDesc('', status2)} icon={this.customIcon(step2Icon)} />
          <Step status="wait" title={this.customTitle(title, status)} description={this.customDesc(endTime, status)} icon={this.customIcon(step3Icon)} />
        </Steps>
      </div>
    )
  }

  customTitle(title: string, status: string) {
    const color = status === 'finish' ? '#dd6572' : '#aeaeae'
    return (
      <div style={{fontSize:'12px', color: color}}>{title}</div>
    )
  }

  customDesc(desc: string, status: string) {
    const color = status === 'finish' ? '#dd6572' : '#aeaeae'
    return (
      <span style={{color: color, fontSize: '12px'}}>{desc}</span>
    )
  }

  customIcon(img: string) {
    return (
      <img src={img} alt="" style={{width: '25px', height: '25px'}}/>
    )
  }

  roomInfoHeader() {
    return (
      <div className="dorm-info-title" style={{border: 'none'}}>
        <span style={{color: '#333333', fontSize: '14px'}}>原房间信息</span>
      </div>
    )
  }
// 原房间信息
  roomInfoComponent() {
    return (
      <div className="component-body">
        <div className="dorm-info">
          <Accordion>
            <Accordion.Panel header={this.roomInfoHeader()}>
              <div className="dorm-info-top">
                <span style={{color: '#868686', fontSize: '14px', marginBottom: '5px'}}>{this.state.roomInfo.store_name}</span>
                <span style={{color: '#1b1b1b', fontSize: '14px', marginTop: '5px'}}>{this.state.roomInfo.building_no}栋 {this.state.roomInfo.room_no} {this.state.roomInfo.bed_no}</span>
              </div>
              <div className="dorm-info-mid">
                <div className="between-row" style={{height: '30px'}}>
                  <span style={{color: '#434343', fontSize: '13px'}}>入住类型：</span>
                  <span style={{color: '#868686', fontSize: '13px'}}>{this.state.roomInfo.property}</span>
                </div>
                <div className="between-row" style={{height: '30px'}}>
                  <span style={{color: '#434343', fontSize: '13px'}}>预订房型：</span>
                  <span style={{color: '#868686', fontSize: '13px'}}>{this.state.roomInfo.room_type_name}</span>
                </div>
                <div className="between-row" style={{height: '30px'}}>
                  <span style={{color: '#434343', fontSize: '13px'}}>租期：</span>
                  <span style={{color: '#868686', fontSize: '13px'}}>{this.state.roomInfo.add_time}{this.state.roomInfo.exit_time? '至':''}{this.state.roomInfo.exit_time}</span>
                </div>
                <div className="between-row" style={{height: '30px'}}>
                  <span style={{color: '#434343', fontSize: '13px'}}>付费方式：</span>
                  <span style={{color: '#868686', fontSize: '13px'}}>{this.state.roomInfo.pay_type}</span>
                </div>
                {this.state.roomInfo.pay_type_id === '2' ?
                  <div className="between-row" style={{height: '30px'}}>
                  <span style={{color: '#434343', fontSize: '13px'}}>扣费部门</span>
                  <span style={{color: '#868686', fontSize: '13px'}}>{this.state.roomInfo.primary_organization}</span>
                </div>: ''}
                <div className="between-row" style={{height: '30px'}}>
                  <span style={{color: '#434343', fontSize: '13px'}}>押金：</span>
                  <span style={{color: '#868686', fontSize: '13px'}}>{this.state.roomInfo.total}</span>
                </div>
              </div>
            </Accordion.Panel>
          </Accordion>
        </div>
      </div>
    )
  }

  // 预订后返回得部分信息
  getInput(){
    return(
      <div>
          <div className="dorm-info-top" style={{borderTop: '1px dashed #eeeeee'}}>
            <span style={{color: '#868686', fontSize: '14px', marginBottom: '5px'}}>{this.roomObj.storeName}</span>
            <span style={{color: '#1b1b1b', fontSize: '14px', marginTop: '5px'}}>{this.roomObj.building_no}栋 {this.roomObj.room_no} {this.roomObj.bed_no}</span>
            <span className="left-top-title">调换房间</span>
          </div>
          <div className="dorm-info-mid">
            <div className="between-row" style={{height: '30px'}}>
              <span style={{color: '#434343', fontSize: '13px'}}>入住类型：</span>
              <span style={{color: '#868686', fontSize: '13px'}}>{this.roomObj.room_property_name}</span>
            </div>
            <div className="between-row" style={{height: '30px'}}>
              <span style={{color: '#434343', fontSize: '13px'}}>预订房型：</span>
              <span style={{color: '#868686', fontSize: '13px'}}>{this.roomObj.roomTypeName}</span>
            </div>
            <div className="between-row" style={{height: '30px'}}>
              <span style={{color: '#434343', fontSize: '13px'}}>付费方式：</span>
              <span style={{color: '#868686', fontSize: '13px'}}>{this.roomObj.pay_type_name}</span>
            </div>
            {this.roomObj.pay_type == 2?
              <div className="between-row" style={{height: '30px'}}>
              <span style={{color: '#434343', fontSize: '13px'}}>扣费部门</span>
              <span style={{color: '#868686', fontSize: '13px'}}>{this.roomObj.pay_type_department_name}</span>
            </div>: ''}
            <div className="dorm-info-bottom" style={{marginBottom:'10px'}}>
              <span style={{color: '#434343', fontSize: '13px'}}>附件：</span>
              {this.attachmentImageList()}
            </div>
            <div className="between-row" style={{height: '30px'}}>
              <span style={{color: '#434343', fontSize: '13px'}}><span style={{color: 'red'}}>*</span>换房时间：</span>
              <span style={{color: '#868686', fontSize: '13px'}}>{this.roomObj.checkin_day} {this.roomObj.checkin_end_day?'至':''} {this.roomObj.checkin_end_day}</span>
            </div>
          </div>
      </div>
    )
  }
  // 请选择
  getSelect(){
    return(
      <div>
        <div className="dorm-info-change dorm-info-title" style={{marginTop:'10px',marginLeft:'5px'}}>
            <span style={{color: '#434343', fontSize: '13px'}}><span style={{color: 'red'}}>*</span>调换房间：</span>
            <div onClick={()=> this.changeBed()} className="change-btn">请选择</div>
          </div>
      </div>
    )
  }
  // 换房信息---预订页面传来得换房信息
  changeBedComponent() {
    return (
      <div className="component-body">
        <div className="dorm-info">
            <div className="dorm-info-title">
              <span style={{color: '#333333', fontSize: '14px'}}>换房信息</span>
            </div>
            {this.roomObj&&this.roomObj.room_id ? this.getInput() : this.getSelect()}
            <div className="dorm-info-bottom">
              <span style={{color: '#434343', fontSize: '13px',width:'90px'}}><span style={{color: 'red'}}>*</span>换房原因：</span>
              <TextareaItem className="remark-input" maxLength={50} onChange={e => this.remarkChange(e)} placeholder="请填写换房原因(50字以内)" rows={3} />
            </div>
        </div>
        </div>
    )
  }
  // 换房结束---新房型信息-apply_room(预订和接口返回字段完成不同，所以创建2个页面)
  changeCompletComponent() {
    return (
      <div className="component-body">
        <div className="dorm-info">
          <div className="dorm-info-title">
            <span style={{color: '#333333', fontSize: '14px'}}>换房信息</span>
          </div>
          <div className="dorm-info-top" style={{borderTop: '1px dashed #eeeeee'}}>
            <span style={{color: '#868686', fontSize: '16px', marginBottom: '5px'}}>{this.applyRoom.store_name}</span>
            <span style={{color: '#1b1b1b', fontSize: '14px', marginTop: '5px'}}>{this.applyRoom.building_no} {this.applyRoom.room_no} {this.applyRoom.bed_no}</span>
            <span className="left-top-title">调换房间</span>
          </div>
          <div className="dorm-info-mid">
            <div className="between-row" style={{height: '30px'}}>
              <span style={{color: '#434343', fontSize: '13px'}}>入住类型：</span>
              <span style={{color: '#868686', fontSize: '13px'}}>{this.applyRoom.property}</span>
            </div>
            <div className="between-row" style={{height: '30px'}}>
              <span style={{color: '#434343', fontSize: '13px'}}>预订房型：</span>
              <span style={{color: '#868686', fontSize: '13px'}}>{this.applyRoom.room_type_name}</span>
            </div>
            <div className="between-row" style={{height: '30px'}}>
              <span style={{color: '#434343', fontSize: '13px'}}>付费方式：</span>
              <span style={{color: '#868686', fontSize: '13px'}}>{this.applyRoom.pay_type}</span>
            </div>
            {this.applyRoom.pay_type_id === '2' ?
              <div className="between-row" style={{height: '30px'}}>
              <span style={{color: '#434343', fontSize: '13px'}}>扣费部门</span>
              <span style={{color: '#868686', fontSize: '13px'}}>{this.applyRoom.apply_organization}</span>
            </div>: ''}
          </div>
          <div className="dorm-info-bottom">
            <span style={{color: '#434343', fontSize: '13px'}}>附件：</span>
            {this.attachmentImageList2()}
          </div>
          <div className="dorm-info-mid">
            <div className="between-row" style={{height: '30px'}}>
              <span style={{color: '#434343', fontSize: '13px'}}><span style={{color: 'red'}}>*</span>换房时间：</span>
              <span style={{color: '#868686', fontSize: '13px'}}>{this.applyRoom.change_room_start_time}至{this.applyRoom.change_room_time}</span>
            </div>
            <div className="between-row" style={{height: '30px'}}>
              <div style={{color: '#434343', fontSize: '13px', width:'90px'}}><span style={{color: 'red'}}>*</span>换房原因：</div>
              <span style={{color: '#868686', fontSize: '13px',overflowWrap: 'break-word', width: '250px'}}>{this.applyRoom.remark}</span>
            </div>
          </div>
        </div>
      </div>
    )
  }

  // 格式化时间
  formatDate(date: any) {
    /* eslint no-confusing-arrow: 0 */
    const pad = (n: number) => n < 10 ? `0${n}` : n;
    const dateStr = `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
    // const timeStr = `${pad(date.getHours())}:${pad(date.getMinutes())}`;
    return `${dateStr}`;
  }
  remarkChange(v: any) {
    this.setState({
      reason: v
    })
  }
  // 选择换房
  changeBed() {
    this.props.history.push({pathname: '/sany/book-room', state: {changeProperty: this.state.roomInfo.property}})
    sessionStorage.setItem('reservationType', 'changeBed')
    sessionStorage.setItem('endTime', this.state.roomInfo.exit_time)
    sessionStorage.setItem('changeDepartTypeName', this.state.roomInfo.pay_type)
    sessionStorage.setItem('changeDepartTypeId', this.state.roomInfo.pay_type_id)
    sessionStorage.setItem('changePrimaryOrganizationName', this.state.roomInfo.primary_organization)
    sessionStorage.setItem('changePayTypeDepartment', this.state.roomInfo.pay_type_department)
  }

  // 构建图片数组
  attachmentImageList() {
    if(this.roomObj&&this.roomObj.img.length> 0) {
      const imgs: [] = this.roomObj.img ?? [] 
      console.log(imgs, 'imgs')
      return (
        <PhotoProvider>
        {imgs.map((item:any, index:any) => (
          <PhotoConsumer key={index} src={item} intro={item}>
            <img src={item} alt="" style={{width: '47px', height: '55px',marginLeft: '10px'}}/>
          </PhotoConsumer>
        ))}
      </PhotoProvider>
      )
    } else {
      return
    }
  }
  attachmentImageList2() {
    if(this.applyRoom&&this.applyRoom.image.length> 0) {
      const imgs: [] = this.applyRoom.image ?? [] 
      console.log(imgs, 'imgs')
      return (
        <PhotoProvider>
        {imgs.map((item:any, index:any) => (
          <PhotoConsumer key={index} src={item} intro={item}>
            <img src={item} alt="" style={{width: '47px', height: '55px',marginLeft: '10px'}}/>
          </PhotoConsumer>
        ))}
      </PhotoProvider>
      )
    } else {
      return
    }
  }

  submitButton() {
    if (this.state.status === 'done') {
      return
    } else {
      let title =  ''
      switch (this.state.status) {
        case '99':
          title = '提交换房申请'
          break;
        case '1':
          title = '取消换房申请'
          break
        case '2':
          title = ''
          break
        default:
          title = '重新提交换房申请'
          break;
      }
      return (
        <Button className="submit-btn"  onClick={() => this.submitClick()}>{title}</Button>
      )
    }
  }
  configNotice() {
    // 1：待审核 2：换房中 3：已换房 4：已取消 5：已驳回 6：已失效
    let notice = '换房申请提交后不可修改，请及认真填写换房信息哦~'
    if (this.state.status === '1' || this.state.status === '2' || this.state.status === '3') {
      notice = '为了保障换房有效,请提交换房前和宿管确认~'
    } else if (this.state.status === '4') {
      notice = '换房申请已取消，需要换房请重新申请~'
    } else if (this.state.status === '5') {
      notice = '换房申请驳回，需要换房请重新申请~'
    } else if (this.state.status === '6') {
      notice = '换房申请已取消，需要换房请重新申请~'
    }
    this.setState({
      notice
    })
  }
  submitClick() {
    if (this.state.status === '99') {
      if(!(this.roomObj&&this.roomObj.room_id)) {
        Toast.info('请选择房型~')
        return
      }
      if(!this.state.reason) {
        Toast.info('请填写换房原因~')
        return
      }
      Modal.alert('换房', '是否确认提交换房申请', [
        { text: '取消', onPress: () => console.log('cancel') },
        // { text: '确定', onPress: () => console.log('ok', this.state.reason) 
        { text: '确定', onPress: () => this.getRoomSave()},
      ])
    } else if (this.state.status === '1' || this.state.status === '2') {
      const obj = {id:this.state.changeId}
      Toast.loading('取消中...')
      changeroomCancelApi({data:obj}).then((res:any)=>{
        Toast.hide()
        if (res.data.code === 'SUCCESS') {
          Toast.info('取消成功~')
          this.changeRoom(1)
        } else {
          Toast.info(res.data.msg)
        }
      })
    } else {
      this.setState({
        status: '99'
      })
      sessionStorage.removeItem('roomObj');
      this.changeRoom('add')
    }
  }
  getRoomSave() {
    const obj = {
      checkin_id: this.checkinId,
      checkin_customer_id:this.customerId,
      pay_type: this.roomObj.pay_type,
      image: this.roomObj.img,
      remark: this.state.reason,
      change_room_start_time: this.roomObj.checkin_day,
      change_room_end_time: this.roomObj.checkin_end_day,
      booking_room_id:this.roomObj.room_id,
      deduction_depart:this.roomObj.pay_type_department,
      booking_bed_id:this.roomObj.bed_id,
      booking_room_type_id:this.roomObj.room_type
    }
    Toast.loading('提交中...')
    changeroomSaveApi({data:obj}).then((res:any)=>{
      Toast.hide()
      if (res.data.code === 'SUCCESS') {
        Toast.info('提交成功~')
        this.changeRoom(1)
      } else {
        Toast.info(res.data.msg)
      }
    })
  }

  render() {
    return (
      <div className="change-bed" ref="body">
        {this.state.notice.length > 0 ? this.noticeBarComponent() : null}
        {this.stepComponent()}
        {/* 换房完成且入住类型是员工宿舍显示 */}
        {this.state.is_need_sign ?this.goSignComponent():null}
        {this.state.status === '5' ? this.rejectReasonComponent() : null}
        {this.roomInfoComponent()}
        {this.state.status === '99' ? this.changeBedComponent() : this.changeCompletComponent()}
        {this.state.status === '2'?'':this.submitButton()}
      </div>
    )
  }
}